import { Injectable, Injector } from '@angular/core';
import { CanActivate, CanActivateChild, Router, ActivatedRouteSnapshot } from '@angular/router';
import { TenantService } from '../services/tenant.service';

@Injectable({
    providedIn: 'root'
})
export class TenantGuard implements CanActivate, CanActivateChild {
    private hasRedirected = false;

    constructor(
        private injector: Injector,
        private router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
        return this.checkTenantAndRedirect(route);
    }

    canActivateChild(route: ActivatedRouteSnapshot): Promise<boolean> {
        return this.checkTenantAndRedirect(route);
    }

    private checkTenantAndRedirect(route: ActivatedRouteSnapshot): Promise<boolean> {
        // Lazily inject TenantService to avoid circular dependency
        const tenantService = this.injector.get(TenantService);
        return tenantService.initializeTenant().then((isValid: boolean) => {

            if (!isValid && !this.hasRedirected) {
                this.hasRedirected = true; // prevent re-redirects
                this.router.navigate(['/'])
            }

            return true;
        });
    }
}



